export const LMS_COLLECTIONS_RESET_STATE = 'LMS_COLLECTIONS_RESET_STATE';
export const LMS_COLLECTIONS_CURRENT_ITEM = 'LMS_COLLECTIONS_CURRENT_ITEM';

export const LMS_COLLECTIONS_REQUEST_LOADING = 'LMS_COLLECTIONS_REQUEST_LOADING';
export const LMS_COLLECTIONS_REQUEST_SUCCESS = 'LMS_COLLECTIONS_REQUEST_SUCCESS';
export const LMS_COLLECTIONS_REQUEST_FAILED = 'LMS_COLLECTIONS_REQUEST_FAILED';

export const LMS_COLLECTIONS_CURRENT_ACTION = 'LMS_COLLECTIONS_CURRENT_ACTION';
export const LMS_COLLECTIONS_RESET_ACTION = 'LMS_COLLECTIONS_RESET_ACTION';